/* Component in the Callsheet to display the Callsheet crew 
   items passed down from the Callsheet
 * Contains the CrewCalls2 component */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../../styles/Callsheets.module.css";
import CrewCalls2 from './CrewCalls2';

const CrewCallsPage2 = ({crewcalls, handleMount, setShow}) => {

  return (
    <div className='mt-3'>
        {/* title */}
        <div className='d-none d-md-block mt-5'>
        <h4 className={`mt-3 pl-3 py-0 px-1 ${styles.SubTitleSpan }`} 
        style={{ textTransform: 'uppercase' }}>Crew Calltimes</h4>
        </div>
        <div className={`mb-3 text-center d-block d-md-none ${styles.SubTitleSpan }`}>
        <span className={`float-right ${styles.Close }`} 
        onClick={() => setShow(false) } >Close</span> 
        <h4 className={`pl-5 text-center`} 
        style={{ textTransform: 'uppercase'}} >Crew Calltimes </h4>
        </div>
        {/* titles */}
        <div >
        <Row>
        <Col lg={6} className='d-none d-lg-block' >
        <Row style={{ textTransform: 'uppercase' }} 
        className={`text-center mx-0 ${styles.TitleBox}`} >
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={5}>
                <p className='mb-0'>Position</p>
            </Col>
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={5}>
                <p className='mb-0 pl-2'>Name</p>
            </Col>
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={2}>
                <p className='mb-0'>Call</p>
            </Col>
        </Row>
        </Col>
        <Col sm={12} lg={6} className='d-none d-sm-block'>
        <Row style={{ textTransform: 'uppercase' }} 
        className={`text-center mx-0  ${styles.TitleBox}`} >
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={5}>
                <p className='mb-0'>Position</p>
            </Col>
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={5}>
                <p className='mb-0 pl-2'>Name</p>
            </Col>
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={2}>
                <p className='mb-0'>Call</p>
            </Col>
        </Row>
        </Col>
        <Col sm={12} lg={6} className='d-block d-sm-none'>
        <Row style={{ textTransform: 'uppercase' }} 
        className={`text-center mx-0  ${styles.TitleBox}`} >
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={8}>
                <p className='mb-0'>Position/Name</p>
            </Col>
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={4}>
                <p className='mb-0'>Call</p>
            </Col>
        </Row>
        </Col>
        </Row>
        </div>
        {/* calls */}
        <Row>
            {crewcalls.results.length ? (
                crewcalls.results.map((crew, index) => (
                    <Col xs={12} lg={6} className='' key={crew.id ?? index}>
                        <CrewCalls2
                            {...crew}
                            handleMount={handleMount}
                            crew={crew}
                        />
                    </Col>
                ))
            ) : ("")}
        </Row>
    </div>
  )
}

export default CrewCallsPage2
